<template>
  <div>
    <top-bar/>
    <div class="content" style="padding: 72px 0">
      <div class="container-fluid">
        <menu-option :menus="menus" :selected="menu" @changeMenu="changeMenu"/>
        <div class="mt-5" v-if="load">
          <loading/>
        </div>
        <div v-else-if="menu === 1">
          <div class="text-right mb-3">
            <button class="btn btn-primary" @click="newAction">Cadastrar Ação</button>
          </div>
          <div class="card shadow-sm" style="min-height: 100px">
            <div class="card-body">
              <table class="table mb-0">
                <thead>
                <tr class="small">
                  <th>Nome</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="t in actions">
                  <td class="align-middle pointer" @click="editAction(t.id)">{{ t.text }}</td>
                  <td class="text-right">
                    <button class="btn btn-primary btn-sm mr-2" @click="editAction(t.id)" style="width: 32px"><i class="fa fa-pencil-alt"></i></button>
                    <button class="btn btn-danger btn-sm mr-2" @click="removeAction(t)" style="width: 32px"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-else-if="menu === 2">
          <div class="text-right mb-3">
            <button class="btn btn-primary" @click="newTemplate">Novo Template</button>
          </div>
          <div class="card shadow-sm" style="min-height: 100px">
            <div class="card-body">
              <table class="table mb-0">
                <thead>
                <tr class="small">
                  <th>Template</th>
                  <th>Chave</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="t in templates">
                  <td class="align-middle pointer" @click="editTemplate(t)">{{ t.type | typeTemplate }}</td>
                  <td class="align-middle pointer" @click="editTemplate(t)">{{ t.name }}</td>
                  <td class="text-right text-nowrap">
                    <button class="btn btn-primary btn-sm mr-2" @click="editTemplate(t)" style="width: 32px"><i class="fa fa-pencil-alt"></i></button>
                    <button class="btn btn-danger btn-sm mr-2" @click="removeTemplate(t)" style="width: 32px"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-else-if="menu === 3">
          <div class="text-right mb-3">
            <button class="btn btn-primary" @click="newFlow">Novo Fluxo</button>
          </div>
          <div class="card shadow-sm" style="min-height: 100px">
            <div class="card-body">
              <table class="table mb-0">
                <thead>
                <tr class="small">
                  <th>Nome</th>
                  <th style="width: 200px">Status</th>
                  <th style="width: 150px;">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="f in flows">
                  <td class="align-middle pointer" @click="editFlow(f)">{{ f.name }}</td>
                  <td class="align-middle text-center text-nowrap">
                    <button class="btn btn-sm mr-1" :class="f.status === 1 ? 'btn-primary' : 'btn-secondary'" @click="toggleFlowStatus(f, 1)">Ativado</button>
                    <button class="btn btn-sm" :class="f.status !== 1 ? 'btn-primary' : 'btn-secondary'" @click="toggleFlowStatus(f, 0)">Desativado</button>
                  </td>
                  <td class="text-right text-nowrap">
                    <button class="btn btn-primary btn-sm mr-2" @click="editFlow(f)" style="width: 32px"><i class="fa fa-pencil-alt"></i></button>
                    <button class="btn btn-danger btn-sm mr-2" @click="removeFlow(f)" style="width: 32px"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-else-if="menu === 4">
          <div class="text-right mb-3">
            <button class="btn btn-primary" @click="newReply()">Novo Resposta</button>
          </div>
          <div class="card shadow-sm" style="min-height: 100px">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                  <tr class="small">
                    <th style="width: 50px">&nbsp;</th>
                    <th>Nome</th>
                    <th style="width: 150px;">&nbsp;</th>
                  </tr>
                  </thead>
                  <draggable handle=".handle" tag="tbody" v-model="replies" @end="saveReplyOrder()">
                    <tr v-for="r in replies">
                      <td class="align-middle pointer handle"><i class="fa fa-bars"></i></td>
                      <td class="align-middle pointer" @click="editReply(r)">{{ r.name }}</td>
                      <td class="text-right align-middle">
                        <button class="btn btn-primary btn-sm mr-2" @click="editReply(r)" style="width: 32px"><i class="fa fa-pencil-alt"></i></button>
                        <button class="btn btn-danger btn-sm mr-2" @click="removeReply(r)" style="width: 32px"><i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="menu === 5">
          <hours/>
        </div>

        <div v-else-if="menu === 6">
          <integrations/>
        </div>
      </div>
    </div>

    <div class="text-center bg-white border-top" v-if="menu === 1 && !load">
      <small class="text-muted">v{{ appVersion }}</small>
    </div>

    <modal @salvar="saveModal" @cancelar="voltarAction">
      <loading v-if="loadModal"/>
      <div v-else-if="menu === 1 && action">
        <h5>{{ action.text || 'Ação' }}</h5>
        <hr>
        <div class="mb-2" v-if="!action.step || action.step === 6">
          <label class="font-weight-bold small mb-0">Pergunta</label>
          <input class="form-control mb-2" placeholder="Informe a pergunta desta ação" v-model="action.text" maxlength="20">
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="font-weight-bold small mb-0">Selecione uma ação</label>
            <select class="form-control" v-model="action.action_id">
              <option :value="null">Nova Ação</option>
              <option :value="a.id" v-for="a in actions">{{ a.text }}</option>
            </select>
          </div>
          <div class="col-md-6 mb-3" v-if="!action.parent_id">
            <label class="font-weight-bold small mb-0">Tipo</label>
            <select class="form-control" v-model="action.step">
              <option :value="1">Boas-vindas</option>
              <option :value="2">Callback</option>
              <option :value="3">Não conseguiu falar</option>
              <option :value="4">Encerramento</option>
              <option :value="5">Fora do Expediente</option>
              <option :value="6">Reutilizável</option>
            </select>
          </div>
        </div>
        <div v-if="!action.action_id">
          <card-mensagem :m="action" @editAction="editAction" :child="true"/>
          <div class="row align-items-center mt-3">
            <div class="col-md-6">
              <label class="mb-0">
                <input type="checkbox" @change="action.close_chat = action.close_chat === 0 ? 1 : 0" :checked="action.close_chat === 1">
                Transferir atendimento
              </label>
              <div v-if="action.close_chat === 1">
                <label class="font-weight-bold small mb-0">Transferir para:</label>
                <select class="form-control" v-model="action.departament_id" required>
                  <option :value="null">Selecione</option>
                  <option :value="d.id" v-for="d in departaments">{{ d.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <small class="d-block mt-3 text-muted" v-if="action.id">Id: {{ action.id }}</small>
      </div>

      <div v-else-if="menu === 2">
        <h5>{{ template.name || 'template' }}</h5>
        <hr>
        <div class="row" v-show="!load">
          <div class="col-md-6 mb-2">
            <label class="font-weight-bold small mb-0">Template</label>
            <select class="form-control" v-model="template.type" required>
              <option :value="null">Selecione</option>
              <option value="1">Alerta de Mensagem</option>
              <option value="2">Nova Conversa</option>
            </select>
          </div>
          <div class="col-md-6 mb-2">
            <label class="font-weight-bold small mb-0">Chave</label>
            <input class="form-control mb-2" placeholder="Chave do template" v-model="template.name" maxlength="20" required>
          </div>
          <div class="col-md-12 mb-2">
            <label class="font-weight-bold small mb-0">Mensagem</label>
            <textarea class="form-control" placeholder="Informe a mensagem do template" v-model="template.content" maxlength="512"></textarea>
          </div>
        </div>
        <div v-if="template.data_body">
          <hr>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="font-weight-bold">Parâmetros</h6>
            <button class="btn btn-primary px-4 btn-sm m-1" type="button" @click="template.data_body.push({ text: '' })">
              <i class="fa fa-plus small"></i>
            </button>
          </div>
          <div class="border rounded-sm py-2 px-1" style="min-height: 60px" v-if="template.data_body.length">
            <div class="d-flex align-items-center" v-for="(p, index) in template.data_body">
              <span class="px-3">{{index + 1}}</span>
              <input type="text" :placeholder="'Parâmetro ' + (index + 1)" class="form-control m-1 mr-2" v-model="p.text" maxlength="20" required/>
              <button class="btn" type="button" @click="removeParameters(index)"><i class="fa fa-trash text-danger small"></i></button>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!loadModal && menu === 3">
        <h5>{{ flow.name || 'Fluxograma' }}</h5>
        <hr>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="font-weight-bold small mb-0">Nome</label>
            <input class="form-control mb-2" placeholder="Nome do fluxograma" v-model="flow.name" maxlength="20" required>
          </div>
          <div class="col-md-6 mb-3">
            <label class="font-weight-bold small mb-0">Status</label>
            <select class="form-control" v-model="flow.status" required>
              <option :value="1">Ativado</option>
              <option :value="0">Desativado</option>
            </select>
          </div>
        </div>
      </div>

      <div v-else-if="!loadModal && menu === 4">
        <h5>{{ reply.name || 'Resposta rápida' }}</h5>
        <hr>
        <div class="row">
          <div class="col-md-12 mb-3">
            <label class="font-weight-bold small mb-0">Nome</label>
            <input class="form-control mb-2" placeholder="Nome da resposta" v-model="reply.name" maxlength="64" required>
          </div>
          <div class="col-md-12 mb-2">
            <label class="font-weight-bold small mb-0">Resposta</label>
            <textarea class="form-control" placeholder="Informe a mensagem da resposta" v-model="reply.response" maxlength="10000" required></textarea>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import MenuOption from "@/components/MenuOption";
import Modal from "@/components/Modal";
import CardMensagem from "@/components/CardMensagem";
import Loading from "@/components/loading";
import Hours from "@/components/Hours";
import Integrations from "@/components/Integrations";
import draggable from "vuedraggable"
import packageJson from "../../package.json";

export default {
  name: "Config",
  components: {Integrations, Hours, Loading, CardMensagem, Modal, MenuOption, TopBar, draggable},
  data() {
    return {
      load: true,
      loadModal: true,
      appVersion: packageJson.version,
      menu: 1,
      menus: [
        { nome: 'Ações', active: true },
        { nome: 'Templates', active: true },
        { nome: 'Fluxos', active: true },
        { nome: 'Respostas', active: true },
        { nome: 'Horários', active: true },
        { nome: 'Integrações', active: true }
      ],
      action: null,
      actions: [],
      departaments: [],
      templates: [],
      flows: [],
      replies: [],

      template: {},
      flow: { name: '', status: 0 },
      reply: { name: '', status: 0, response: '' }
    }
  },

  methods: {
    getActions() {
      this.load = true;
      this.$http.get('actions')
        .then(response => {
          this.load = false;
          this.actions = response.data || [];

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    getActionId(id) {
      this.loadModal = true;
      this.$http.get(`actions/${id}`)
        .then(response => {
          this.loadModal = false;
          this.action = response.data;

        }, res => {
          this.loadModal = false;
          console.log(res);
        });
    },

    getDepartaments() {
      this.load = true;
      this.$http.get('departaments')
        .then(response => {
          this.departaments = response.data || [];

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    saveAction() {
      if (this.action.actions.length && this.action.actions.find(a => a.text.length > 20)) {
        this.$swal('O tamanho máximo de uma pergunta é 20 caracteres.');
        return;
      }

      this.$http.post('actions', this.action)
        .then(response => {
          this.load = false;
          const data = response.data || {};

          if (data.success) {
            this.$swal(data.msg ? "Salvo com os seguintes erros:\n" + data.msg : "Salvo com sucesso");

            if (!this.action.id) {
              this.getActions();
            }

            if (data.id) {
              this.editAction(data.id, true);
            }

          } else {
            this.$swal(data.msg || "Não foi possível salvar essa ação");
          }

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    saveModal(callback) {
      if (this.menu === 1) {
        this.saveAction();

      } else if (this.menu === 2) {
        this.saveTemplate(callback);

      } else if (this.menu === 3) {
        this.saveFlow(callback);

      } else if (this.menu === 4) {
        this.saveReply(callback);
      }
    },

    changeMenu(m) {
      this.menu = m;

      if (this.menu === 2 && !this.templates.length) {
        this.getTemplates();

      } else if (this.menu === 3 && !this.flows.length) {
        this.getFlows();

      } else if (this.menu === 4 && !this.replies.length) {
        this.getReplies();
      }
    },

    editAction(b) {
      if (b) {
        this.$emit('openModal');
        this.getActionId(b);
      }
    },

    removeAction(a) {
      this.$swal({
        text: "Deseja realmente remover esta ação?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then(r => {
        if (r) {
          this.action = a;
          this.action.delete = true;
          this.saveAction();
        }
      })
    },

    voltarAction() {
      if (this.menu === 1 && this.action.parent_id) {
        this.editAction(this.action.parent_id);

      } else {
        this.action = null;
      }
    },

    newAction() {
      this.loadModal = false;
      this.action = {
        step: 6,
        text: '',
        answer: '',
        type: 1,
        action_id: null,
        close_chat: 0,
        order: 0,
        actions: [],
        departament_id: null
      }
      this.$emit('openModal');
    },

    getTemplates() {
      this.load = true;
      this.$http.get('templates')
        .then(response => {
          this.load = false;
          this.templates = response.data || [];

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    newTemplate() {
      this.loadModal = false;
      this.template = {
        name: '',
        content: '',
        type: null,
        data_body: []
      }
      this.$emit('openModal');
    },

    editTemplate(t) {
      this.loadModal = false;
      this.template = {
        id: t.id,
        name: t.name,
        content: t.content || '',
        type: t.type,
        data_body: t.data_body
      }
      this.$emit('openModal');
    },

    removeTemplate(t) {
      this.$swal({
        text: "Deseja realmente remover este template?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then(r => {
        if (r) {
          this.template = t;
          this.template.delete = true;
          this.saveTemplate();
        }
      });
    },

    removeParameters(index) {
      this.template.data_body.splice(index, 1);
    },

    saveTemplate(callback) {
      this.loadModal = true;
      this.$http.post('templates', this.template)
        .then(response => {
          this.loadModal = false;

          if (response.data && response.data.id) {
            this.getTemplates();

            if (callback) {
              callback(true);
            }

          } else {
            this.$swal("Não foi possível salvar esse template");
          }

        }, res => {
          this.loadModal = false;
          console.log(res);
        });
    },

    getFlows() {
      this.load = true;
      this.$http.get('flows')
        .then(response => {
          this.load = false;
          this.flows = response.data || [];

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    newFlow() {
      this.loadModal = true;
      this.flow = { name: '', status: 1 }
      this.$nextTick(() => {
        this.$emit('openModal');
        this.loadModal = false;
      });
    },

    editFlow(f) {
      this.loadModal = false;
      this.flow = { id: f.id, name: f.name, status: f.status }
      this.$emit('openModal');
    },

    removeFlow(f) {
      if (f.status === 1) {
        this.$swal('Você não pode remover um fluxograma que esteja ativado!');

      } else {
        this.$swal({
          text: "Deseja realmente remover este fluxograma?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then(r => {
          if (r) {
            this.flow = f;
            this.flow.delete = true;
            this.saveFlow();
          }
        });
      }
    },

    saveFlow(callback) {
      this.loadModal = true;
      this.$http.post('flows', this.flow)
        .then(response => {
          this.loadModal = false;

          if (response.data && response.data.id) {
            this.getFlows();
            this.getActions();

            if (callback) {
              callback(true);
            }

          } else {
            this.$swal("Não foi possível salvar esse fluxograma");
          }

        }, res => {
          this.loadModal = false;
          console.log(res);
        });
    },

    toggleFlowStatus(f, status) {
      if (f.status !== status) {
        this.flow = f;
        this.flow.status = status;
        this.saveFlow();
      }
    },

    getReplies() {
      this.load = true;
      this.$http.get('replies')
        .then(response => {
          this.load = false;
          this.replies = response.data || [];
          this.$store.state.replies = [];

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    newReply() {
      this.loadModal = true;
      this.reply = { name: '', status: 0, response: '' }
      this.$nextTick(() => {
        this.$emit('openModal');
        this.loadModal = false;
      });
    },

    editReply(f) {
      this.loadModal = false;
      this.reply = { id: f.id, name: f.name, status: f.status, response: f.response }
      this.$emit('openModal');
    },

    removeReply(data) {
      this.$swal({
        text: "Deseja realmente remover esta resposta?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then(r => {
        if (r) {
          this.reply = data;
          this.reply.delete = true;
          this.load = true;
          this.saveReply();
        }
      });
    },

    saveReply(callback) {
      this.loadModal = true;
      this.$http.post('replies', this.reply)
        .then(response => {
          this.load = false;
          this.loadModal = false;

          if (response.data && response.data.id) {
            this.getReplies();

            if (callback) {
              callback(true);
            }

          } else {
            this.$swal("Não foi possível salvar esta Resposta");
          }

        }, res => {
          this.load = false;
          this.loadModal = false;
          console.log(res);
        });
    },

    saveReplyOrder() {
      const replies = this.replies.map((r, index) => {
        return {
          id: r.id, sort_order: (index + 1)
        }
      });

      this.$http.post('replies/order', { replies })
        .then(response => {

        }, res => {
          this.$swal('Erro ao alterar a ordem das respostas.')
        });
    }
  },

  mounted() {
    const user = this.$store.state.dataUser || {};
    const canManageIntegrations = user.type === 1;

    if (!canManageIntegrations) {
      this.$swal('Acesso não autorizado', 'Apenas administradores gerais podem gerenciar integrações.', 'error');
      this.$router.replace('/chat');
      return;
    }

    this.getDepartaments();
    this.getActions();
  },

  filters: {
    typeTemplate(type) {
      switch (type) {
        case 1:
          return 'Alerta de Mensagem';
        case 2:
          return 'Nova Conversa';
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
</style>
